import JobListLinks from 'components/joblist/JobListLinks';
import { JobPortalScreen } from 'jobs.types';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  numOfResults: number;
  maxEntries: number;
  setScreen: (screen: JobPortalScreen) => void;
  loginUrl: string;
}

const JobportalResultsHeader = ({
  numOfResults,
  maxEntries,
  setScreen,
  loginUrl,
}: Props) => {
  const { t } = useTranslation('jobs');

  if (numOfResults > 0 && !maxEntries) {
    return (
      <div className="jobportal__results-header">
        <h2 aria-live="polite" className="jobportal__total">
          {t('jobportal_results', { count: numOfResults })}
        </h2>
        <JobListLinks setScreen={setScreen} loginUrl={loginUrl} />
      </div>
    );
  }

  return null;
};

export default JobportalResultsHeader;
